const FADE_IN_MS = 350
const FADE_OUT_MS = 250
const OVERLAY_ID = '__sceneTransitionOverlay'
const STYLE_ID = '__sceneTransitionStyle'

let styleInjected = false

const injectStyle = () => {
    if (styleInjected) return
    styleInjected = true
    const style = document.createElement('style')
    style.id = STYLE_ID
    style.textContent = `
        #${OVERLAY_ID} {
            position: absolute;
            inset: 0;
            z-index: 99999;
            background: rgba(0, 0, 0, 0.12);
            backdrop-filter: blur(0px);
            -webkit-backdrop-filter: blur(0px);
            opacity: 0;
            pointer-events: none;
            transition: opacity ${FADE_IN_MS}ms ease-in-out, backdrop-filter ${FADE_IN_MS}ms ease-in-out;
            will-change: opacity, backdrop-filter;
        }
        #${OVERLAY_ID}.visible {
            opacity: 1;
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            transition: opacity ${FADE_OUT_MS}ms ease-in-out, backdrop-filter ${FADE_OUT_MS}ms ease-in-out;
        }
    `
    document.head.appendChild(style)
}

const getOverlay = () => {
    let el = document.getElementById(OVERLAY_ID)
    if (!el) {
        el = document.createElement('div')
        el.id = OVERLAY_ID
        const viewer = document.querySelector('#viewer') || document.body
        viewer.appendChild(el)
    }
    return el
}

const raf = () => new Promise(resolve => requestAnimationFrame(resolve))
const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms))

export const sceneTransition = async (fn) => {
    injectStyle()
    const overlay = getOverlay()

    overlay.classList.add('visible')
    await wait(FADE_IN_MS)

    try {
        await fn()
    } finally {
        await raf()
        await raf()
        overlay.classList.remove('visible')
        await wait(FADE_OUT_MS)
    }
}